import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'trueFilter'
})
export class TrueFilterPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    //console.log(value);
    let ret = Object.keys(value).map(key => {
        if(value[key]){
            return key;
        };
    });
    //console.log(ret);
    return ret;

  }

}



// WEBPACK FOOTER //
// ./src/app/true-filter.pipe.ts